// account
export const ACCOUNT_SUMMARY = 'accountSummary';
export const ACCOUNT_DETAILS = 'accountDetails';
export const COMMUNICATION_PREFERENCES = 'communicationPreferences';
export const CREATE_ACCOUNT = 'createAccount';
export const FAVORITE_PRODUCTS = 'favoriteProducts';
export const FORGOT_PASSWORD = 'forgotPassword';
export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const LOYALTY_SUMMARY = 'loyaltySummary';
export const MY_ACCOUNT_HOME = 'myAccountHome';
export const ORDER_HISTORY = 'orderHistory';
export const PASSWORD_RESET_MODE = 'resetPassword';
export const PERSONAL_DETAILS = 'personalDetails';
export const PREVIOUS_ONLINE_ORDER = 'previousOnlineOrder';
export const RECENTLY_PURCHASED_PRODUCTS = 'recentlyPurchasedProducts';
export const SHOP_PREFERENCES = 'shopPreferences';
export const VERSION_ONE = 'v1';
export const VERSION_TWO = 'v2';
export const CREATE_LOYALTY = 'createLoyalty';
export const FETCH_LOYALTY = 'fetchLoyalty';
export const NAVIGATION_ITEMS = [
  {
    id: ACCOUNT_SUMMARY,
    label: 'Account Summary',
  },
  {
    id: ORDER_HISTORY,
    label: 'Purchase History',
  },
  {
    id: RECENTLY_PURCHASED_PRODUCTS,
    label: 'Recent Products',
  },
  {
    id: FAVORITE_PRODUCTS,
    label: 'Favorite Products',
  },
  {
    id: LOYALTY_SUMMARY,
    label: 'Loyalty Summary',
  },
  {
    id: PERSONAL_DETAILS,
    label: 'Personal Details',
  },
  {
    id: SHOP_PREFERENCES,
    label: 'Shop Preferences',
  },
  {
    id: COMMUNICATION_PREFERENCES,
    label: 'Communication Preferences',
  },
  {
    id: LOGOUT,
    label: 'Sign Out',
  },
];
